import React, { useState } from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import { IoClose } from 'react-icons/io5';
import { MdFastfood } from "react-icons/md";
import ImageUploading from 'react-images-uploading';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

import InputMoney from "../ListItem/InputMoney";
import { registerAdicionais } from "../../services/api";
import '../../styles/modal-shared.css';

const ModalRegisterItemAdicional = ({
    setShowRegisterItemAdicional,
    showRegisterItemAdicional,
    setRefresh,
    idGrupoToRegister,
    typeAdicional
}) => {
    const { t } = useTranslation('categorias');

    const empresa = localStorage.getItem('empresa');
    const empresaParse = JSON.parse(empresa);
    const idEmpresa = empresaParse.id_empresa;

    const id_grupo = idGrupoToRegister;
    const userID = "sad29389das32f";

    const [valuePreco, setValuePreco] = useState(0);
    const [savingAdicional, setSavingAdicional] = useState(false);

    const [images, setImages] = useState([]);
    const maxNumber = 1;
    const maxMbFileSize = 2 * 1024 * 1024;

    const onChangeImg = (imageList) => {
        setImages(imageList);
    };

    const SignUpSchema = Yup.object().shape({
        title: Yup.string().required(t('actions.required')),
    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        initialValues: { title: "" },
        onSubmit: (values) => handleSubmitAPI(values.title, values.preco),
    });

    const onChange = (event, nameObject, isNumber) => {
        setValuePreco(isNumber ? Number(event.target.value) : event.target.value);
        formik.setFieldValue("preco", isNumber ? Number(event.target.value) : event.target.value);
    };

    const handleBack = () => setShowRegisterItemAdicional(!showRegisterItemAdicional);

    const handleSubmitAPI = (title, preco) => {
        setSavingAdicional(true);
        const createdBy = userID;
        const out = false;
        const price = preco || 0;

        registerAdicionais(createdBy, id_grupo, idEmpresa, title, price, out, images).then(cast => {
            if (cast.status === 201) {
                toast(cast.data.msg, { autoClose: 5000, type: "success" });
            } else {
                toast(cast.data.msg, { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            const msg = err.response?.data?.msg || t('additional.deleteError');
            toast(msg, { autoClose: 5000, type: "error" });
        }).finally(() => {
            setSavingAdicional(false);
            setShowRegisterItemAdicional(!showRegisterItemAdicional);
            setRefresh(prev => !prev);
            formik.setFieldValue("title", "");
            formik.setFieldValue("preco", 0);
            setValuePreco(0);
        });
    };

    return (
        <div className={showRegisterItemAdicional ? 'pdj-modal-overlay' : 'pdj-modal-overlay--hidden'}>
            <div className="pdj-modal-box">
                <form onSubmit={formik.handleSubmit}>

                    {/* Header */}
                    <div className="pdj-modal-header">
                        <div className="pdj-modal-header-text">
                            <h2 className="pdj-modal-title">{t('registerAdditionalModal.title')}</h2>
                        </div>
                        <button type="button" className="pdj-modal-close-btn" onClick={handleBack}>
                            <IoClose />
                        </button>
                    </div>

                    {/* Body */}
                    <div className="pdj-modal-body">

                        {/* Nome */}
                        <div className="pdj-modal-field">
                            <label className="pdj-modal-label">
                                {t('registerAdditionalModal.name')}
                                <span className="pdj-modal-required">*</span>
                            </label>
                            <input
                                className="pdj-modal-input"
                                placeholder={t('registerAdditionalModal.namePlaceholder')}
                                id="title"
                                type="text"
                                name="title"
                                onChange={formik.handleChange}
                                value={formik.values.title}
                            />
                            {formik.errors.title && (
                                <span className="pdj-modal-error">{formik.errors.title}</span>
                            )}
                        </div>

                        {/* Preco */}
                        <div className="pdj-modal-field" style={{ maxWidth: '240px' }}>
                            <label className="pdj-modal-label">
                                {t('registerAdditionalModal.price')}
                            </label>
                            <InputMoney
                                onChange={(event) => onChange(event, 'price', true)}
                                value={valuePreco}
                                className="pdj-modal-input"
                                placeholder="0,00"
                            />
                        </div>

                        {/* Imagem */}
                        <div className="pdj-modal-field">
                            <label className="pdj-modal-label">
                                {t('registerAdditionalModal.image')}
                            </label>
                            <ImageUploading
                                multiple
                                value={images}
                                onChange={onChangeImg}
                                maxNumber={maxNumber}
                                maxFileSize={maxMbFileSize}
                                acceptType={["jpg", "jpeg", "png", "webp"]}
                                dataURLKey="data_url"
                            >
                                {({
                                    imageList,
                                    onImageUpload,
                                    onImageUpdate,
                                    onImageRemove,
                                    isDragging,
                                    dragProps,
                                    errors
                                }) => (
                                    <div>
                                        <div
                                            onClick={images.length === 0 ? onImageUpload : undefined}
                                            {...dragProps}
                                            className={`pdj-modal-upload${isDragging ? ' pdj-modal-upload--dragging' : ''}${imageList.length > 0 ? ' pdj-modal-upload--has-image' : ''}`}
                                        >
                                            {imageList.length === 0 && (
                                                <>
                                                    <MdFastfood className="pdj-modal-upload-icon" />
                                                    <div className="pdj-modal-upload-title">
                                                        {t('addItemModal.imageChoose')}
                                                    </div>
                                                    <div className="pdj-modal-upload-hint">
                                                        {isDragging ? "Solte aqui..." : t('addItemModal.imageDragDrop')}
                                                    </div>
                                                </>
                                            )}
                                            {imageList.map((image, index) => (
                                                <div key={index} className="pdj-modal-upload-preview">
                                                    <img
                                                        src={image['data_url']}
                                                        alt="Preview"
                                                        style={{ maxHeight: '140px', maxWidth: '100%', borderRadius: '8px', objectFit: 'cover' }}
                                                    />
                                                    <div className="pdj-modal-upload-actions">
                                                        <button
                                                            type="button"
                                                            className="pdj-modal-btn pdj-modal-btn--secondary"
                                                            onClick={(e) => { e.stopPropagation(); onImageUpdate(index); }}
                                                        >
                                                            {t('addItemModal.imageChange')}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="pdj-modal-btn pdj-modal-btn--danger"
                                                            onClick={(e) => { e.stopPropagation(); onImageRemove(index); }}
                                                        >
                                                            {t('addItemModal.imageRemove')}
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {errors && (
                                            <div style={{ marginTop: '4px' }}>
                                                {errors.maxNumber && <span className="pdj-modal-error">{t('addItemModal.imageMaxNumber')}</span>}
                                                {errors.acceptType && <span className="pdj-modal-error">{t('addItemModal.imageInvalidFormat')}</span>}
                                                {errors.maxFileSize && <span className="pdj-modal-error">{t('addItemModal.imageMaxFileSize')}</span>}
                                            </div>
                                        )}

                                        <div className="pdj-modal-upload-info">
                                            {t('addItemModal.imageMaxSize')}
                                        </div>
                                    </div>
                                )}
                            </ImageUploading>
                        </div>

                    </div>

                    {/* Footer */}
                    <div className="pdj-modal-footer">
                        <button type="button" className="pdj-modal-btn pdj-modal-btn--secondary" onClick={handleBack}>
                            {t('actions.cancel')}
                        </button>
                        <button
                            type="submit"
                            className="pdj-modal-btn pdj-modal-btn--primary"
                            disabled={savingAdicional}
                        >
                            {savingAdicional ? t('addItemModal.saving') : t('actions.save')}
                        </button>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default ModalRegisterItemAdicional;
